// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__P3_V5","active":"Modal_active__3IZ22","modal__content":"Modal_modal__content__3ThV2","modalButton":"Modal_modalButton__95nyT","img":"Modal_img__1zHSI"};